import { useSelector } from "react-redux";
import { RestAvatar } from "../../Avatars/RestAvatar";
import { TravelAvatar } from "../../Avatars/TravelAvatar";
import { LiftAvatar } from "../../Avatars/LiftAvatar";

export const RestTravelBadge = ({ dateString, size = 18, popOutView=false }) => {
  const {
    info: { restAndTravel },
  } = useSelector(({ team }) => team);

  return (
    <div
      style={{
        ...(!popOutView && { position: "absolute" }),
        bottom: 4,
        display: "flex",
        justifyContent: "center",
        gap: 4,
        flexWrap: "wrap-reverse"
      }}
    >
      {restAndTravel && (restAndTravel[dateString] & 2) ? (
        <RestAvatar size={size} />
      ) : <></>}

      {restAndTravel && (restAndTravel[dateString] & 1) ? (
        <TravelAvatar size={size} />
      ) : <></>}

      {restAndTravel && (restAndTravel[dateString] & 4) ? (
        <LiftAvatar size={size} />
      ) : <></>}
    </div>
  );
};
